// extracted by mini-css-extract-plugin
export default {"container":"db_link_container__veKQx"};